export default __webpack_public_path__ + "reactjs.f73a9b6e.png";